<div class="main-container lg-view">
	<h3>Change Date</h3>

	<div class="main-form">
		<form [formGroup]="formModel">
			<fieldset>
				<legend>{{ job.jobName }}</legend>

				<mat-form-field class="calendar" [floatLabel]="'always'">
					<mat-label>Current</mat-label>
					<input matInput [matDatepicker]="currentPicker" formControlName="currentDate">
					<mat-datepicker-toggle matSuffix [for]="currentPicker"></mat-datepicker-toggle>
					<mat-datepicker #currentPicker></mat-datepicker>
				</mat-form-field>

				<mat-form-field class="calendar" [floatLabel]="'always'">
					<mat-label>New Date</mat-label>
					<input matInput [disabled]="isJobFlowDone" [matDatepicker]="newPicker" formControlName="newDate">
					<mat-datepicker-toggle matSuffix [for]="newPicker"></mat-datepicker-toggle>
					<mat-datepicker #newPicker></mat-datepicker>
				</mat-form-field>

				<mat-form-field [floatLabel]="'always'">
					<mat-label>Comment</mat-label>
					<textarea matInput [disabled]="isJobFlowDone" formControlName="comment" rows="5"></textarea>
				</mat-form-field>
			</fieldset>
			<fieldset *ngIf="additionalAssets" class="list">
				<legend>Additional Updated {{additionalAssets.assetType}}</legend>

				<ul>
					<li *ngFor="let asset of additionalAssets.assets">
						<mat-checkbox [disabled]="isJobFlowDone" (change)="onOtherAssetChange($event, asset.assetId)">
							{{asset.assetName}}</mat-checkbox>
					</li>
				</ul>
			</fieldset>
		</form>
	</div>
</div>

<div class="actions-container md-view">
	<ng-container
		*ngIf="isActionAvailable">
		<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'..'"></action-button>
		<action-button [icon]="ButtonIcons.Submit" [name]="'Submit'" [clickAction]="submitEtaChange.bind(self)"
			[disabled]="formModel.invalid || isJobFlowDone"></action-button>
	</ng-container>

	<div class="actions-placeholder-message" *ngIf="pageType === PageType.Customer && (customerPreferences.preferences.isJobAutoSkipped || customerPreferences.preferences.isNotificationDisabled)">
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
		<span
			*ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
			{{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.BothDisabled }}</span>
	</div>

	<div class="actions-placeholder-message" *ngIf="BitwiseHelper.and(pageType, PageType.AssigneeOrVendor) && customerPreferences.preferences.isJobAutoSkipped">
		<span *ngIf="customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
	</div>
</div>